@use "@fukuri-admins/ui/layout" as *;

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.innerWrapper {
  position: relative;
  overflow: auto;
}

.contentWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  background-color: background('Primary');
  border-radius: borderRadius('xl');
  @include elevation("3");
}

.modalRoot {
  display: flex;
  flex-direction: column;
  gap: spacing('24');
  padding: spacing('24');

  &.mdCenter {
    width: 512px;
    text-align: center;
  }

  &.md {
    width: 512px;
  }

  &.lg {
    width: 864px;
  }

  &.xl {
    width: 1232px;
  }
}

.closeButton {
  position: absolute;
  top: spacing('4');
  right: spacing('4');
}

.header {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
}

.title {
  @include typography('Jp/16_W6');
  color: text('High');
}

.description {
  @include typography('Jp/14_W3');
  color: text('Low');
}

.contentBody {
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: spacing('8');

  .modalRoot.mdCenter & {
    flex-direction: column-reverse;
    gap: spacing('8');

    button {
      width: 100%;
    }
  }
}
